//MyKaizenCreate.jsx 

import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Loader from '../../components/utils/Loader';
import useFetch from '../../hooks/useFetch';
import MainLayout from '../../layouts/MainLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTree } from '@fortawesome/free-solid-svg-icons';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import '../../styles/Concerns.css';
import '../../styles/Alert.css';
import Tooltip from '../../components/utils/Tooltip';
import { GenerateKaizenCode } from '../../components/GenerateThink5whysCode';


const MyKaizenCreate = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();
  const [fetchData, { loading }] = useFetch();
  const { kaizenId } = useParams();
  const mode = kaizenId === undefined ? "add" : "update";
  const [kaizen, setKaizen] = useState(null);
  const [showMicrophoneAlert, setShowMicrophoneAlert] = useState(false);
  const [formErrors, setFormErrors] = useState({});
  const [error, setError] = useState(null);
  const [startTime, setStartTime] = useState(false);
  const [countFormErrors, setCountFormErrors] = useState(0);

  const [autoKaizenCode, setAutoKaizenCode] = useState(GenerateKaizenCode());

  const [formData, setFormData] = useState({
    userId: authState.user._id,
    title: "",
    description: "",
    kaizenCategory: "",
    kaizenCode: autoKaizenCode,
    kaizenStartDate: new Date(),
    kaizenEndDate: new Date(),
    dateCreated: new Date(),
    isActive: true,
    isDeleted: false,
    remarks: "",
  });
  // console.log("Mode is: ",mode);
  useEffect(() => {
    document.title = mode === "add" ? "Add" : "Update";
  }, [mode]);

  useEffect(() => {
    if (mode === "update") {
      const config = { 
        url: `/kaizen/mykaizenforupdate`, 
        method: "post", 
        headers: { Authorization: authState.token }, 
        data: {kaizenId: kaizenId}
      };
      // console.log("Getting Data for Update here",config);
      // console.log("Existing formData",formData);

      fetchData(config, { showSuccessToast: false }).then((data) => {
        // console.log("response for update - ",data.kaizen);
        setKaizen(data.kaizen);
        setFormData({
          userId: data.kaizen.userId,
          title: data.kaizen.title,
          description: data.kaizen.description,
          kaizenCategory: data.kaizen.kaizenCategory,
          kaizenCode: data.kaizen.kaizenCode,
          kaizenStartDate: data.kaizen.kaizenStartDate,
          kaizenEndDate: data.kaizen.kaizenEndDate,
          dateCreated: data.kaizen.dateCreated,
          isActive: data.kaizen.isActive,
          isDeleted: data.kaizen.isDeleted,
          remarks: data.kaizen.remarks,
        });
      })
      .catch((error) => {
        console.error("Error fetching Kaizen data:", error);
        setError("Error fetching Kaizen data");
      });
    }
  }, [mode, authState, kaizenId, fetchData, setKaizen]);

  const handleChange = (e) => {
    setFormData({
      ...formData, [e.target.name]: e.target.value
    });
  };

  const handleReset = e => {
    e.preventDefault();
    setFormData({
      userId: kaizen.userId,
      title: kaizen.title,
      description: kaizen.description,
      kaizenCategory: kaizen.kaizenCategory,
      kaizenCode: kaizen.kaizenCode,
      kaizenStartDate: kaizen.kaizenStartDate,
      kaizenEndDate: kaizen.kaizenEndDate,
      dateCreated: kaizen.dateCreated,
      isActive: kaizen.isActive,
      isDeleted: kaizen.isDeleted,
      remarks: kaizen.remarks,
    });
  }

  const handleSubmit = e => {
    e.preventDefault();
    const error = validateForm(formData);
    // console.log("error : ",error," no. of error",Object.keys(error).length);
    setFormErrors(error);
    setCountFormErrors(Object.keys(error).length);
    // console.log("setFormError : ",setFormErrors);

    if (Object.keys(error).length > 0) {
      setFormErrors(
        Object.keys(error).reduce((total, key) => {
          total[key] = error[key];
          return total;
        }, {})
      );
      return;
    }

    if (mode === "add") {
      const config = { 
        url: "/kaizen", 
        method: "post",
        data: {formData: formData, userId: authState.user._id, dateCreated: new Date()}, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data ",JSON.stringify(formData, null, 2), " User ",authState.user._id);


      fetchData(config).then(() => {
        navigate("/mykaizen-list");
      });
    }
    else {
      const config = { 
        url: `/kaizen/${kaizenId}`, 
        method: "put", 
        data: formData, 
        headers: { Authorization: authState.token } 
      };
      // console.log("Posting Data for kaizen update ",config);

      fetchData(config).then(() => {
        navigate("/mykaizen-list");
      })
      .catch((error) => {
        console.error("Error updating Kaizen:", error);
        setError("Error updating Kaizen");
      });
    }
  }

  const validateForm = formData => {
    const errors = {};
    if (!formData.kaizenCategory) {
      errors.kaizenCategory = "Please select a Kaizen category";
    }
    if (!formData.kaizenStartDate) {
      errors.kaizenStartDate = "Start Date is required";
    }
    if (!formData.kaizenEndDate) {
      errors.kaizenEndDate = "End Date is required";
    } else if (new Date(formData.kaizenEndDate) < new Date(formData.kaizenStartDate)) {
      errors.kaizenEndDate = "End Date must be greater than Start Date";
    }
    if (!formData.title) {
      errors.title = "Title is required";
    } else if (formData.title.length > 100) {
      errors.title = "Title cannot exceed 100 characters";
    }
    if (!formData.description) {
      errors.description = "Description is required";
    } else if (formData.description.length > 1000) {
      errors.description = "Description cannot exceed 1000 characters";
    }
    return errors;
  }

  const fieldError = (field) => (
    <p className={`mt-1 text-pink-600 text-sm ${formErrors[field] ? "block" : "hidden"}`}>
      <i className='mr-2 fa-solid fa-circle-exclamation'></i>
      {formErrors[field]}
    </p>
  )
  return (
    <>
      <MainLayout>
        <div className='mt-12 '>
          <h3 className='text-lg mx-2 border-b border-b-gray-300 text-white'>My Kaizen</h3>
        </div>
        <div className='m-auto my-2 p-2 border-2 shadow-md rounded-md md:w-7/12 w-full'>
            {loading ? (
              <Loader />
            ) : (
            <div className='text-m'>
              <div className='flex justify-center'>
                <h2 className="ml-2 text-xl text-yellow-200">{mode === "add" ? "Add New Kaizen" : "Edit Kaizen"}</h2>
              </div>
              <div className="border-container-gray ml-8">
                <div className="mb-4 text-sm">
                    <p className="text-yellow-300">Your Kaizen Code: {autoKaizenCode}</p>
                </div>
                <div className="mb-4 text-sm">
                    <label htmlFor="kaizenCategory">Kaizen Category: </label>
                    <br />
                    <select name="kaizenCategory" id="kaizenCategory" value={formData.kaizenCategory}
                      onChange={handleChange} style={{ border: '1px solid #ccc', padding: '8px', height: 'auto', minHeight: '40px' }}>
                      <option value="">Select Kaizen Category</option>
                      <option value="Personal">Personal</option>
                      <option value="Family">Family</option>
                      <option value="Student">Student</option>
                      <option value="Children">Children</option>
                      <option value="Parent">Parent</option>
                      <option value="Professional">Profesional</option>
                      <option value="Social">Social</option>
                      <option value="Worker">Worker</option>
                      <option value="Operator">Operator</option>
                      <option value="Factory">Factory</option>
                      <option value="Manager">Manager</option>
                      <option value="Engineer">Engineer</option>
                      <option value="Healthcare">Healthcare</option>
                      <option value="Business">Business</option>
                      <option value="Government">Government</option>
                      <option value="Institution">Institution</option>
                      <option value="Others">Others</option>
                    </select>
                  </div>
                  <div className="mb-4 text-sm">
                    <label htmlFor="title">Kaizen Title*:</label>
                    <br />
                    <input 
                      type="text" 
                      name="title" 
                      id="title" 
                      value={formData.title} 
                      placeholder="Enter the title..."
                      maxLength="100"
                      onChange={handleChange}
                      style={{
                        border: '1px solid #ccc',
                        padding: '8px',
                        width: '100%',
                        boxSizing: 'border-box',
                      }} 
                    />
                    {fieldError("title")}
                  </div>
                  <div className="mb-4 text-sm">
                      <label htmlFor="description">Kaizen Description*:</label>
                    <textarea 
                      type="description" 
                      name="description" 
                      id="description" 
                      value={formData.description}
                      placeholder={showMicrophoneAlert ? "Write here or Click Mic for Voice Input...":"Write here.."}
                      onChange={handleChange}
                      maxLength="2000"
                      style={{
                        border: '1px solid #ccc',
                        padding: '2px',
                        backgroundColor: '#f0f0f0', 
                        color: '#000000',
                        maxWidth: '650px', 
                        maxHeight: '150px' 
                      }}
                    />
                    {fieldError("description")}
                  <div className="mb-4 text-sm">
                    <label htmlFor="kaizenStartDate">Kaizen Start Date*:</label>
                    <br />
                    <DatePicker
                      selected={formData.kaizenStartDate}
                      onChange={date => setFormData({ ...formData, kaizenStartDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="kaizenStartDate"
                      name="kaizenStartDate"
                      className="form-control"
                    />
                    {fieldError("kaizenStartDate")}
                  </div>
                  <div className="mb-4 text-sm">
                    <label htmlFor="kaizenEndDate">Kaizen End Date*:</label>
                    <br />
                    <DatePicker
                      selected={formData.kaizenEndDate}
                      onChange={date => setFormData({ ...formData, kaizenEndDate: date })}
                      dateFormat="dd/MM/yyyy"
                      id="kaizenEndDate"
                      name="kaizenEndDate"
                      className="form-control"
                    />
                    {fieldError("kaizenEndDate")}
                  </div>
                  <div>
                </div>
              </div>
            </div>
            <div className="border-container flex flex-col justify-center">
                  <div className="flex justify-center">
                    {Object.keys(formErrors).length > 0 && (
                      <div className="form-errors text-red-300 justify-center items-center">
                        {Object.keys(formErrors).map((key) => (
                          <div className="flex justify-center items-center" key={key}>{formErrors[key]}</div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className="flex justify-center">
                    <button className='bg-primary text-white px-4 py-2 font-medium hover:bg-primary-dark' onClick={handleSubmit}>{mode === "add" ? "Add New" : "Update"}</button>
                    <button className='ml-4 bg-red-500 text-white px-4 py-2 font-medium' onClick={() => navigate("/mykaizen-list")}>Cancel</button>
                    {mode === "update" && <button className='ml-4 bg-blue-500 text-white px-4 py-2 font-medium hover:bg-blue-600' onClick={handleReset}>Reset</button>}
                  </div>
                </div>
          </div>
          )}
        </div>
      </MainLayout>
    </>
  )
}

export default MyKaizenCreate